import { Directive, HostListener } from '@angular/core';
import { BaseDirective } from './base.directive';

@Directive({
  selector: '[appOnlyNumbers]',
  standalone: true,
})
export class OnlyNumbersDirective extends BaseDirective {
  constructor() { super(); }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.teclaPermitidaPresionada(event)) return;
    this.filterInput(event);
  }

  filterInput(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
